'use client';

import { Input, type InputProps } from '@heroui/input';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { forwardRef, useState } from 'react';

export type PasswordInputProps = {
    label?: string;
    name?: string;
    placeholder?: string;
    isRequired?: boolean;
    autoComplete?: 'current-password' | 'new-password';
    type?: 'password' | 'new-password';
} & Omit<InputProps, 'type'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
    (
        {
            label = 'Password',
            name = 'password',
            placeholder = '••••••••',
            isRequired = true,
            autoComplete = 'current-password',
            type = 'password',
            ...props
        },
        ref
    ) => {
        const [visible, setVisible] = useState(false);

        return (
            <Input
                autoComplete={`${autoComplete} webauthn`}
                endContent={
                    <button
                        aria-label={visible ? 'Hide password' : 'Show password'}
                        onClick={() => setVisible((v) => !v)}
                        tabIndex={-1}
                        type="button"
                    >
                        {visible ? (
                            <EyeOff className="h-4 w-4 text-default-400" />
                        ) : (
                            <Eye className="h-4 w-4 text-default-400" />
                        )}
                    </button>
                }
                // isRequired={isRequired}
                label={label}
                labelPlacement="outside"
                name={name}
                placeholder={placeholder}
                ref={ref}
                startContent={<Lock className="text-default-400" />}
                type={visible ? 'text' : 'password'}
                variant="bordered"
                {...props}
            />
        );
    }
);

PasswordInput.displayName = 'PasswordInput';
